import React, {HTMLAttributes} from 'react';
import {Images} from '@/constants';
import {cn} from '@/utils/common_functions';

interface LogoProps extends HTMLAttributes<HTMLDivElement> {
  imageStyle?: HTMLDivElement['className'];
  textStyle?: HTMLParagraphElement['className'];
  showText?: boolean;
}

export const Logo: React.FC<LogoProps> = props => {
  const {imageStyle, textStyle, showText = true} = props;
  return (
    <div className="flex flex-col relative items-center">
      <img
        alt="logo"
        className={cn([
          'w-[29px] sm:w-[38px] md:w-[48px] lg:w-[58px] aspect-[29/38]',
          imageStyle,
        ])}
        src={Images.logo_transparent}
      />
      {showText && (
        <p
          id="logo-text"
          className={cn([
            'text-nowrap text-[8px] sm:text-[11px] md:text-[14] lg:text-base font-FigtreeBold',
            textStyle,
          ])}>
          Second Opinion
        </p>
      )}
    </div>
  );
};

/**
 * 58/76 -> 29/38
 */
